import * as _ from "lodash";

// used with the Bootstrap Tabs to create scrollable tabs
export class TabScrollerControl {
    private scrollBarWidths: number = 40;
    private container: JQuery;

    public constructor(container: JQuery) {
        const me: TabScrollerControl = this;

        this.container = container;

        this.container.find(".tab-scroller-scroller-right").click(() => {
            me.container.find(".tab-scroller-scroller-left").fadeIn("slow");
            me.container.find(".tab-scroller-scroller-right").fadeOut("slow");
            me.container.find(".tab-scroller-list").animate({ left: "+=" + me.widthOfHidden() + "px" }, "slow");
        });

        this.container.find(".tab-scroller-scroller-left").click(() => {
            me.container.find(".tab-scroller-scroller-right").fadeIn("slow");
            me.container.find(".tab-scroller-scroller-left").fadeOut("slow");
            me.container.find(".tab-scroller-list").animate({ left: "-=" + me.getLeftPosition() + "px" }, "slow");
        });
    }

    public reset(): void {
        this.container.find(".tab-scroller-scroller-left").hide();
        this.container.find(".tab-scroller-scroller-right").hide();
        this.container.find(".tab-scroller-list").css("left", 0);
    }

    public resize(): void {
        const outerWidth: number = _.defaultTo<number>(this.container.find(".tab-scroller-wrapper").outerWidth(), 0);

        if (outerWidth < this.widthOfList()) {
            this.container.find(".tab-scroller-scroller-right").show();
        } else {
            this.container.find(".tab-scroller-scroller-right").hide();
        }

        if (this.getLeftPosition() < 0) {
            this.container.find(".tab-scroller-scroller-left").show();
        } else {
            this.container.find(".tab-scroller-item").animate({ left: "-=" + this.getLeftPosition() + "px" }, "slow");
            this.container.find(".tab-scroller-scroller-left").hide();
        }
    }

    public scrollRight(): void {
        if (!this.container.find(".tab-scroller-scroller-right").is(":hidden")) {
            this.container.find(".tab-scroller-scroller-left").fadeIn("slow");
            this.container.find(".tab-scroller-scroller-right").fadeOut("slow");

            this.container.find(".tab-scroller-list").animate({ left: "+=" + this.widthOfHidden() + "px" }, "slow");
        }
    }
    private widthOfList(): number {
        let itemsWidth: number = 0;
        this.container.find(".tab-scroller-list li").each(function(): void {
            itemsWidth += _.defaultTo<number>($(this).outerWidth(), 0);
        });
        return itemsWidth;
    }

    private widthOfHidden(): number {
        const outerWidth: number = _.defaultTo<number>(this.container.find(".tab-scroller-wrapper").outerWidth(), 0);
        return outerWidth - this.widthOfList() - this.getLeftPosition() - this.scrollBarWidths;
    }

    private getLeftPosition(): number {
        return this.container.find(".tab-scroller-list").position().left;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/tabScroller.ts